__turbopack_context__.v({
  "alert": "InlineInfoAlert-module-scss-module__G2AhSq__alert",
  "icon": "InlineInfoAlert-module-scss-module__G2AhSq__icon",
  "iconGlyph": "InlineInfoAlert-module-scss-module__G2AhSq__iconGlyph",
  "message": "InlineInfoAlert-module-scss-module__G2AhSq__message",
});
